/* eslint-disable react/no-danger, no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as SwatchbookUtils from '../../modules/swatchbook-utils';
import {
  // getEmailShareUrl,
  getFacebookShareUrl,
  getPinterestShareUrl,
  getTwitterShareUrl,
} from '../../utils/social-media-sharing';
import { saveItemToAccount, removeItemFromAccount } from '../../modules/consumer-account/storage-actions';
import { getIdFromAssetUrl } from '../../modules/widen-utils';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = { itemInSwatchbook: false };
    // Init Swatchbook Utils
    this.SwatchbookUtils = SwatchbookUtils;
    this.SwatchbookUtils.init();
    // Add handlers
    this.modalClickHandler = this.modalClickHandler.bind(this);
    this.addToSwatchbookHandler = this.addToSwatchbookHandler.bind(this);
    this.removeFromSwatchbookHandler = this.removeFromSwatchbookHandler.bind(this);
    this.closeBtnRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('click', this.modalClickHandler);
  }

  componentDidUpdate() {
    const { active, item } = this.props.modal;
    // Is account login modal open
    const loginModalDiv = document.getElementById('acct-login-modal');
    const isLoginModalOpen = loginModalDiv ? loginModalDiv.classList.contains('modal-visible') : false;
    // Set focus of gallery photo modal
    if (item && active && !isLoginModalOpen) {
      this.closeBtnRef.current.focus();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.modalClickHandler);
  }

  formatThumbnailUrl() {
    const { imageUrl } = this.props.modal.item;
    return (imageUrl.indexOf('1024px') !== -1) ? imageUrl.replace(/1024px/, '360px') : imageUrl;
  }

  resetGalleryFocus() {
    const { active, item } = this.props.modal;
    if (item.id && active && document.querySelector(`#image-${item.id} button`)) {
      document.querySelector(`#image-${item.id} button`).focus();
    }
  }

  modalClickHandler(event) {
    const { item } = this.props.modal;
    const { handleModalClick } = this.props;
    if (event.target.classList.contains('modal') && event.target.classList.contains('show')) {
      handleModalClick(item);
      this.resetGalleryFocus();
    } else if (event.target.classList.contains('btn-close')) {
      handleModalClick(item);
      this.resetGalleryFocus();
    }
    // Check swatchbook status
    if (item) {
      const { id } = item;
      this.setState(() => ({
        itemInSwatchbook: this.SwatchbookUtils.getItemById(id) !== null,
      }));
    }
  }

  addToSwatchbookHandler() {
    const { item } = this.props.modal;
    const {
      id,
      newId,
      title,
      filename,
      imageUrl,
      imageAlt,
      description,
      productLineName,
      productLineUrl,
      productLineId,
    } = item;
    const { updateModal } = this.props;

    if (window.useLocalStorage) {
      this.SwatchbookUtils.saveSwatchbookItem({
        type: 'photo',
        id,
        newId,
        title,
        filename,
        imageUrl,
        imageAlt: (imageAlt !== undefined) ? imageAlt.replace(/"/g, '') : '',
        description,
        productLineName,
        productLineUrl,
        productLineId,
      });
    } else {
      saveItemToAccount(
        'photo',
        {
          imageUrl,
          thumbUrl: this.formatThumbnailUrl(),
          description,
          productLineId,
          productLineName,
        },
        (data) => {
          if (data.success) {
            updateModal(item);
          }
        },
      );
    }
  }

  removeFromSwatchbookHandler() {
    const { item } = this.props.modal;
    const { assetId, updateModal } = this.props;

    if (window.useLocalStorage) {
      this.SwatchbookUtils.removeSwatchbookItem({
        type: 'photo',
        value: item.id,
      });
    } else {
      removeItemFromAccount(
        'photo',
        assetId,
        () => {
          updateModal(item);
        },
      );
    }
  }

  render() {
    const { active, item } = this.props.modal;
    const { savedToFavorites, assetId } = this.props;
    const { itemInSwatchbook } = this.state;
    const { location, PhotoShareUrl } = window;
    const { origin } = location;
    let shareLink = '';
    if (item) {
      if (item.type === 'Image') {
        // Set sharelink html
        shareLink = encodeURIComponent(`${origin}${PhotoShareUrl}#${getIdFromAssetUrl(item.imageUrl)}`);
      }
    }
    return (
      <div className="modal-container gallery-modal-container">
        {(item !== '' && item !== undefined)
        ? (
          <div className={`modal fade ${active ? 'show' : ''}`} id={`modal-${item.id}`} role="dialog" aria-labelledby={`modal-label-${item.id}`}>
            <div className="modal-dialog modal-dialog-centered mx-auto" role="document">
              {item.type === 'Video'
                ? (
                  <div className="container">
                    <div className="modal-content">
                      <div className="row row-eq-height">
                        <div className="col-12 col-md-8 col-lg-9">
                          <div className="modal-video">
                            <iframe id="modal-iframe" className="modal-iframe" src={`${item.videoUrl}/?rel=0`} title={item.title} allowFullScreen />
                          </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-3">
                          <div className="modal-description">
                            <button type="button" className="btn-close btn-close-white" aria-label="Close Modal" onClick={event => this.modalClickHandler(event)} ref={this.closeBtnRef} />
                            <h2 className="heading-sm modal-title" id={`modal-label-${item.id}`}>{item.title}<span className="sr-only"> Details</span></h2>
                            <div className="video-description">
                              <p dangerouslySetInnerHTML={{ __html: item.description }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="container">
                    <div className="modal-content">
                      <div className="row row-eq-height">
                        <div className="col-12 col-md-8 col-lg-9">
                          <div className="modal-image">
                            <img className="w-100" src={item.imageUrl} alt={item.imageAlt} />
                          </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-3">
                          <div className="modal-description d-flex flex-column justify-content-center">
                            <button type="button" className="btn-close btn-close-white" aria-label="Close Modal" onClick={event => this.modalClickHandler(event)} ref={this.closeBtnRef} />
                            <h2 className="heading-sm modal-title" id={`modal-label-${item.id}`}>{item.productLineName}<span className="sr-only"> Details</span></h2>
                            <div className="image-caption m-b-lg">
                              <p className="mb-0" dangerouslySetInnerHTML={{ __html: item.description }} />
                              <p>
                                <a href={item.productLineUrl}><span className="link link-secondary">Learn more</span><span className="sr-only"> about {item.productLineName}</span></a>
                              </p>
                            </div>
                            <div className="btns d-flex gap-xxs justify-content-between align-items-start flex-row flex-wrap mb-4 align-items-center m-b-xl">
                              <a className="btn btn-secondary mb-2" href={`/swatches?product-line-id=${item.productLineId}`}>Order Swatches</a>
                              <div>
                                <div className="heading-xxs mb-0">Share Photo</div>
                                <ul className="image-caption list-unstyled d-flex flex-row flex-wrap pt-0 mb-0">
                                  <li className="me-3"><a href={`${getFacebookShareUrl()}${shareLink}`} title="Facebook" className="share-fb-link link link-teal" id="share-fb" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                                  <li className="me-3"><a href={`${getTwitterShareUrl()}Check out this photo from the Bali Blinds Design Gallery&url=${shareLink}`} title="Twitter" className="share-tw-link link link-teal" id="share-tw" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                                  <li className="me-3"><a href={`${getPinterestShareUrl()}${shareLink}&media=${item.imageUrl}&description=${item.description}`} title="Pinterest" className="share-pt-link link link-teal" id="share-pt" target="_blank" rel="noopener noreferrer">Pinterest</a></li>
                                </ul>
                              </div>
                            </div>
                            <div className="favorites-item-btn-wrapper">
                              {(itemInSwatchbook || savedToFavorites)
                              ? (
                                <button className="favorites-item-btn update-swatchbook-btn btn btn-secondary rounded-0" data-asset-id={`${savedToFavorites ? assetId : ''}`} onClick={event => this.removeFromSwatchbookHandler(event)}>
                                  <span>
                                    <div className="remove-item-btn-icon">
                                      <div className="icon" />
                                    </div>
                                    <div className="favorites-item-btn-label">Remove from My Favorites</div>
                                  </span>
                                </button>
                              ) : (
                                <button className="favorites-item-btn update-swatchbook-btn btn btn-secondary rounded-0" onClick={event => this.addToSwatchbookHandler(event)}>
                                  <span>
                                    <div className="add-item-btn-icon">
                                      <div className="icon" />
                                    </div>
                                    <div className="favorites-item-btn-label">Add to My Favorites</div>
                                  </span>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        ) : ''}
      </div>
    );
  }
}

Modal.propTypes = {
  handleModalClick: PropTypes.func.isRequired,
  modal: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    item: PropTypes.shape(PropTypes.object.isRequired),
  }),
  savedToFavorites: PropTypes.bool.isRequired,
  assetId: PropTypes.string.isRequired,
  updateModal: PropTypes.func.isRequired,
};

export default Modal;
/* eslint-enable react/no-danger, no-console */
